import React from "react";
import { Link } from "react-router-dom";
import "../css/footer.scss";
import brandConfig from "../config";

function Footer() {
  return (
    <footer className="site-footer" role="contentinfo">
      <div className="site-footer__top">
        <div className="footer-brand">
          <Link className="brand brand--footer" to="/">
            <span className="brand__mark">{brandConfig.brandInitial}</span>
            <span>{brandConfig.brandName}</span>
          </Link>
          <p>{brandConfig.description}</p>
          <span className="status-dot">Local demo · no account required</span>
        </div>
        <div>
          <h2>Explore</h2>
          {brandConfig.navigation.map((item) => (
            <Link key={item.to} to={item.to}>
              {item.label}
            </Link>
          ))}
        </div>
        <div>
          <h2>Policies</h2>
          {brandConfig.footerLinks.map((item) => (
            <Link key={item.to} to={item.to}>
              {item.label}
            </Link>
          ))}
        </div>
        <div>
          <h2>Contact</h2>
          <p>
            <strong>{brandConfig.legalName}</strong>
          </p>
          <a href={`mailto:${brandConfig.email}`}>{brandConfig.email}</a>
          <address>{brandConfig.address}</address>
        </div>
      </div>
      <div className="site-footer__bottom">
        <span>
          © {new Date().getFullYear()} {brandConfig.legalName}.{" "}
          {brandConfig.brandName} is a trading brand.
        </span>
        <span>Original browser games · local demonstration store</span>
      </div>
    </footer>
  );
}

export default Footer;
